import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, CloseButton, Container, FloatingLabel, Form, Image, ProgressBar, Table } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import { LoginInfo } from '../App';
import DynamicDialog from './DynamicDialog';
import * as ImageUtil from '../service/ImageUtil';
import ImageFile from '../domain/ImageFile';

const ShortTextDialog = (props) => {
    const location = useLocation()
    const {t,i18n} = useTranslation()
    const [files,setFiles] = useState([])
    const [message, setMessage] = useState('')
    const [messageShow, setMessageShow] = useState(false)

    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    function textareaSizing(labelElementId,elementId){
        let labelElement = document.querySelector(labelElementId)
        labelElement.style.lineHeight = "20px"
        let lineHeight = labelElement.style.lineHeight.replace(/[^0-9.]+/,'')
        let n = labelElement.value.match(/\n/g)
        if(n === null){
            n = 1
        } else {
            n = n.length + 1
        }
        if(n <= 5){
            n = 5
        }
        labelElement.style.height = lineHeight * n + 30 + "px"
        document.querySelector(elementId).style.height = lineHeight * n + 30 + "px"
        document.querySelector("#short-text-limit").textContent = document.querySelector(elementId).value.length + " / 200"
    }
    useEffect(() => {
        files.forEach((imgFile,i) => {
            console.log(imgFile)
            ImageUtil.load(files,imgFile.file,i,(data,data2,data3)=>{
                if(data === false){
                    imgFile.error = true
                    setMessageShow(true)
                    setMessage(message+"「"+imgFile.file.name+"」が読み込めませんでした。\r\n")
                    // エラーなら削除
                    setFiles(files.map(f=>f).filter((imgFile,idx)=>!imgFile.error))
                } else {
                    let img = document.getElementById("img"+i)
                    if(img) img.src = data
                    imgFile.imageData = data
                    imgFile.imageDataMiddle = data2
                    imgFile.imageDataOriginal = data3
                    imgFile.imageDataEdited = data3
                }
            })
        })
    },[files])

    const [uploading, setUploading] = useState(false)
    const [progressNow, setProgressNow] = useState(0)
    const [progressLabel, setProgressLabel] = useState(0)

    function upload(text) {
        setUploading(true)
        //サーバに保存する処理　画像のURLが戻される
        let fd = new FormData()
        fd.append("description",text)
        files.forEach(obj => {
            fd.append("file[]",obj.file)
            fd.append("nsfw[]",obj.nsfw ? 1 : 0)
            fd.append("fileType[]","image")
        })
        let req = new XMLHttpRequest()
        req.open("POST",ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/upload/shortText")
        req.withCredentials = true
        req.onreadystatechange = () => {
            if(req.readyState === 4 && req.status === 200){
                if(req.responseText !== ""){
                    var r = JSON.parse(req.responseText)
                    if(r.result){
                        document.querySelector("#short-text").value = ""
                        setFiles([])
                        props.switch(false)
                        props.reloadTimeline()
                    } else {
                        alert(r.errors.join(","))
                    }
                    setUploading(false)
                }
            }
        }
        req.onerror = () => {
          setUploading(false)
          setProgressNow(0)
          setProgressLabel(0)
          alert("通信エラーが発生しました。")
        }
        req.upload.onprogress = (e) => {
            let per = Math.floor(e.loaded / e.total * 100)
            let label = ""
            if(per === 100){
                label = "登録中"
            } else {
                label = per + "%"
            }
            setProgressNow(per)
            setProgressLabel(label)
        }
        req.send(fd)
    }

    return(
        props.show ? (
            <DynamicDialog width={360} height={500} switch={props.switch} content={<>
                <div style={{backgroundColor:"inherit",width:"auto"}} className='p-0'
                >
                    <FloatingLabel controlId="short-text" label="ひとことどうぞ" className='mb-3 w-100'>
                        <Form.Control
                            as="textarea"
                            style={{ height: '100px' }}
                            required
                            className='short-text'
                            onChange={() => textareaSizing("#short-text",".short-text")}
                        />
                    </FloatingLabel>
                    <Button variant='outline-primary'
                    onClick={() => {
                        let text = document.querySelector("#short-text").value.trim().replace(/(\r\n|\r|\n){2,}/g,"\r\n\r\n")
                        if(text.length === 0 && files.length === 0){
                            alert("ファイルの添付または本文を記載してください。")
                            return
                        }
                        if(text.length > 1000){
                            alert("上限は200文字です。")
                            return
                        }
                        upload(text)
                    }}
                    >投稿</Button> <span id="short-text-limit"></span>
                    <br />
                    {uploading ? <ProgressBar id="short-text-progress" animated now={progressNow} label={progressLabel} style={{margin:"10px 0"}} /> : ""}
                </div>
                <div className='image-container d-flex justify-content-start m-0 flex-wrap mt-3'>
                    {files.map((d,i) => {
                        return (
                            <div className='m-0' key={i} style={{width:"100px",height:"100px",border:"1px solid #BBBBBB",borderRadius:"2px",position:"relative",cursor:"pointer"}}>
                                <CloseButton style={{position:"absolute",backgroundColor:"#FFFFFF",color:"#000000",top:"5px",left:"5px"}}
                                    onClick={() => setFiles(files.map(f=>f).filter((imgFile,idx)=>idx !== i))}
                                />
                                {d.nsfw ? <Badge bg="danger" style={{position:"absolute",bottom:"5px",right:"5px"}}>NSFW</Badge> : ""}
                                <Image src={d.imageDataMiddle} id={"img"+i} key={i} style={{objectFit:"cover",width:"100%",height:"100%"}}
                                    onClick={() => {
                                        setFiles(files.map((d,j) => {
                                            d.nsfw = i === j ? !d.nsfw : d.nsfw
                                            return d
                                        }))
                                    }}
                                />
                            </div>
                        )
                    })}
                </div>
                </>
            } onDrop={(e) => {
                e.preventDefault()
                let max = 4 - files.length
                for(let i = 0;i < e.dataTransfer.files.length && i < max && i < 4;i++){
                    let img = new ImageFile({file:e.dataTransfer.files[i]})
                    files.push(img)
                }
                setFiles([].concat(files))
            }} />
        ) : ""
    )
}

export default ShortTextDialog;
